/**
 * aswbe authorization eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';
import { AswbeAuthorizationRequest } from '../model/aswbeAuthorizationRequest';
import { AswbeAuthorizationResponse } from '../model/aswbeAuthorizationResponse';
import { InitializeGoshokaiNetRequest } from '../model/initializeGoshokaiNetRequest';
import { InitializeGoshokaiNetResponse } from '../model/initializeGoshokaiNetResponse';
import { LogoutResponse } from '../model/logoutResponse';
import { RefreshAmcmemberBalanceResponse } from '../model/refreshAmcmemberBalanceResponse';
import { Type } from '../model/type';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationApiService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * # 1. 概要 1. ASW BEとしてのログインを行う。S1 認可APIのSSOログインAPIを呼び出し、必要に応じてMindsから会員情報を取得し、ASWDB(Tx)のS2パーソナライズ情報の会員情報に情報を保存する。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリングAPI(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. リクエストパラメータの搭乗者に含まれているかチェック要否、マイル減算者の会員かチェック要否のいずれかに必要が指定された場合は、以下の処理で指定されたチェックを行う。   1. リクエストパラメータの予約番号と搭乗者姓、搭乗者名を基に作成したcredentialファイル情報をパラメータとしてPNR情報取得APIを呼び出す。   1. PNR情報取得APIから返却されたPNR情報に対して、以下のチェックを行い条件に一致しない場合、ステータスコード400(Bad request)でエラー情報を返却する。     1. 搭乗者に含まれているかチェック要否に必要が指定された場合、会員PNRで航空券の支払手段にGMOPを含み搭乗者の会員のいずれかの条件に一致するか判定する。     1. マイル減算者の会員かチェック要否に必要が指定された場合、特典PNRでマイル減算者の会員の条件に一致するか判定する。 1. リクエストパラメータの会員番号とパスワード、自動ログインフラグをパラメータとしてS1 SSOログインAPIを呼び出す。リクエストパラメータに会員番号がない場合は、認可検証APIのレスポンスのuuidをキーとしASWDB(Tx)S2パーソナライズ情報の会員情報の会員番号を利用する。 1. S1SSOログインAPIからエラーが返却された場合、返却されたエラーを以下の単位で当処理のエラーとし、ステータスコード400(Bad request)でエラー情報を返却する。   1. AMC会員番号が存在しない、またはパスワード間違い   1. MINDSから返却された処理結果がアカウントロック   1. MINDSから返却された処理結果が同時接続数制限   1. 上記以外のエラーが発生 1. S1SSOログインAPIを呼び出した時の会員番号をパラメータとしてMindsより会員情報ならびにSKYコイン残高を取得する。 ※ S1で作成しているシステムAPI(会員データ(参照)API)を利用する。 ※ SSOログインでリアルログインした場合、S1パーソナライズにMindsから取得した最新情報が入るが、S1パーソナライズ情報にはS2で必要な会員情報がすべて入っていないため、S2として別途でMindsにアクセスする必要がある。 1. Mindsから取得した会員情報のカードステータスがアクティブ会員(親会員または単独)でない場合、ステータスコード401(Unauthorized)でエラー情報を返却する。 1. 会員情報、SKYコイン残高を基にASWDB(Tx)S2パーソナライズ情報の会員情報とユーザ共通情報のログインステータスを更新する。 1. ステータスコード200(正常)を返却し処理を終了する。  # 3. データ更新内容 1. ASWDB(Tx)のS2パーソナライズ情報   1. ユーザ共通情報の項目について以下の内容を更新する。 |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |ユーザ共通情報のログインステータス|リアルログイン|||    1. 会員情報の項目については会員データ(参照)APIの戻り値で更新する。&lt;br&gt;※以下の項目は変換処理を加えた上で更新を行う。&lt;br&gt; |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |会員情報のable-I氏名の姓|条件より導出した姓|S1システムAPI(会員データ(参照)API)のレスポンスのable-I氏名|able-I氏名を分割した姓| |会員情報のable-I氏名の名|条件より導出した名|S1システムAPI(会員データ(参照)API)のレスポンスのable-I氏名|able-I氏名を分割した名| |会員情報の性別|条件より導出した性別|S1システムAPI(会員データ(参照)API)のレスポンスの性別|性別が\&quot;M\&quot;の場合は”male”、性別が\&quot;F\&quot;の場合は”female”、上記以外\&quot;\&quot;| |会員情報の生年月日|条件より導出した生年月日|S1システムAPI(会員データ(参照)API)のレスポンスの生年月日|yyyy-MM-dd形式に変換|    # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public aswbeAuthorizationPost(
    generated?: AswbeAuthorizationRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<AswbeAuthorizationResponse>;
  public aswbeAuthorizationPost(
    generated?: AswbeAuthorizationRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<AswbeAuthorizationResponse>>;
  public aswbeAuthorizationPost(
    generated?: AswbeAuthorizationRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<AswbeAuthorizationResponse>>;
  public aswbeAuthorizationPost(
    generated?: AswbeAuthorizationRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/aswbe-authorization`;
    return this.httpClient.request<AswbeAuthorizationResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 1. ご紹介ねっとからの流入処理として、リクエストで指定された紹介者情報をASWDB(Tx)S2パーソナライズ情報のユーザ共通情報に保持する処理である。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリングAPI(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. レスポンスのuuidをキーとしASWDB(Tx)S2パーソナライズ情報を取得し、ユーザ共通情報のご紹介ねっと情報を、呼び出し元より渡されたご紹介ねっと情報に更新する。 1. ステータスコード200(正常)を返却し処理を終了する。  # 3. データ更新内容 1. ASWDB(Tx)のS2パーソナライズ情報 |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |ユーザ共通情報のご紹介ねっと経由識別|true||| |ユーザ共通情報のご紹介ねっと紹介番号|ご紹介ねっと紹介番号|呼び出し元より渡された情報|| |ユーザ共通情報のご紹介ねっと紹介者名(姓)|ご紹介ねっと紹介者名(姓)|呼び出し元より渡された情報|| |ユーザ共通情報のご紹介ねっと紹介者名(名)|ご紹介ねっと紹介者名(名)|呼び出し元より渡された情報||    # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public initializeGoshokaiNetPost(
    generated?: InitializeGoshokaiNetRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<InitializeGoshokaiNetResponse>;
  public initializeGoshokaiNetPost(
    generated?: InitializeGoshokaiNetRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<InitializeGoshokaiNetResponse>>;
  public initializeGoshokaiNetPost(
    generated?: InitializeGoshokaiNetRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<InitializeGoshokaiNetResponse>>;
  public initializeGoshokaiNetPost(
    generated?: InitializeGoshokaiNetRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/initialize-goshokai-net`;
    return this.httpClient.request<InitializeGoshokaiNetResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 1. ASW BEとしてのログアウトを行う。S1 認可APIのログアウトを呼び出し、ASWDB(Tx)のS2パーソナライズ情報のユーザ共通情報のログインステータスを未ログインに更新、および会員情報をクリアする。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリングAPI(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. S1 ログアウトAPIを呼び出す。 1. リクエストパラメータの会員番号とパスワード、自動ログインフラグをパラメータとしてS1 SSOログインAPIを呼び出す。リクエストパラメータに会員番号がない場合は、認可検証APIのレスポンスのuuidをキーとしASWDB(Tx)S2パーソナライズ情報の会員情報の会員番号を利用する。 1. S1SSOログインAPIからエラーが返却された場合、返却されたエラーを以下の単位で当処理のエラーとし、ステータスコード400(Bad request)でエラー情報を返却する。 1. 認可検証APIのレスポンスのuuidをキーとし、ASWDB(Tx)S2パーソナライズ情報の更新を行う。 1. ステータスコード200(正常)を返却し処理を終了する。  # 3. データ更新内容 1. ASWDB(Tx)のS2パーソナライズ情報 |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |ユーザ共通情報のログインステータス|未ログイン||  |会員情報|値なし|||   # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public logoutPost(
    generated?: object,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<LogoutResponse>;
  public logoutPost(
    generated?: object,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<LogoutResponse>>;
  public logoutPost(
    generated?: object,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<LogoutResponse>>;
  public logoutPost(
    generated?: object,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/logout`;
    return this.httpClient.request<LogoutResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 1. ASWDB(Tx)S2パーソナライズ情報の会員情報のSKYコイン残高、マイル残高、アップグレードポイントを最新化する。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリングAPI(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. S1 認可検証APIのレスポンスのuuidをキーとして、ASWDB(Tx)S2パーソナライズ情報を取得する。 1. パーソナライズ情報のユーザ共通情報のログインステータスがリアルログイン以外の場合、 ステータスコード400(Bad request)でエラー情報を返却する。 1. S2パーソナライズ情報の会員情報の会員番号をパラメータとしてMindsよりSKYコイン残高、マイル残高、アップグレードポイントを取得する。 ※ S1で作成しているシステムAPI(会員データ(参照)API)を利用する。 1. 会員情報のSKYコイン残高、マイル残高、アップグレードポイントを、Mindsより取得したSKYコイン残高、マイル残高、アップグレードポイントで上書きし、認可検証APIのレスポンスのuuidをキーとしASWDB(Tx)のS2パーソナライズ情報を更新する。 1. ステータスコード200(正常)を返却し処理を終了する。  # 3. データ更新内容 1. ASWDB(Tx)のS2パーソナライズ情報 |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |会員情報のマイル残高|残マイル|S1で作成しているシステムAPI(会員データ(参照)API)のレスポンス|integer型に変換| |会員情報のマイル残高（AFAグループ）|マイル残高（AFAグループ）|S1で作成しているシステムAPI(会員データ(参照)API)のレスポンス|integer型に変換| |会員情報のSKYコイン残高|ANAｅクーポン合計数|S1で作成しているシステムAPI(会員データ(参照)API)のレスポンス|integer型に変換| |会員情報のアップグレードポイント数残高（今年度）|アップグレードポイント数残高（今年度）|S1で作成しているシステムAPI(会員データ(参照)API)のレスポンス|integer型に変換| |会員情報のアップグレードポイント数残高（次年度）|アップグレードポイント数残高（次年度）|S1で作成しているシステムAPI(会員データ(参照)API)のレスポンス|integer型に変換|    # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public refreshAmcmemberBalancePost(
    generated?: object,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<RefreshAmcmemberBalanceResponse>;
  public refreshAmcmemberBalancePost(
    generated?: object,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<RefreshAmcmemberBalanceResponse>>;
  public refreshAmcmemberBalancePost(
    generated?: object,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<RefreshAmcmemberBalanceResponse>>;
  public refreshAmcmemberBalancePost(
    generated?: object,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/refresh-amcmember-balance`;
    return this.httpClient.request<RefreshAmcmemberBalanceResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
